import { UseFormReturn } from 'react-hook-form';

export const DELIVERY_METHODS = ['SFTP', 'AS2', 'API', 'INTEGRATION', 'MANUAL', 'OTHER'];
// The backend only gates its push step on `enabled`; pull methods (API, MANUAL, OTHER) ignore the flag.
const PUSH_DELIVERY_METHODS = ['SFTP', 'AS2', 'INTEGRATION'];

const UPLOAD_FIELDS = {
    enabled: { methods: PUSH_DELIVERY_METHODS, clearedValue: false },
    targetPathFileExport: { methods: ['SFTP'], clearedValue: '' },
    targetPathOriginalDocument: { methods: ['SFTP'], clearedValue: '' },
    sendOriginalDocument: { methods: ['SFTP', 'AS2'], clearedValue: false },
    sendOriginalEmail: { methods: ['SFTP'], clearedValue: false },
    sendAdditionalFiles: { methods: ['SFTP', 'AS2'], clearedValue: false },
    additionalFileTypes: { methods: ['SFTP', 'AS2'], clearedValue: [] },
    targetPathAdditionalFiles: { methods: ['SFTP'], clearedValue: '' },
};

export type UploadConfigField = keyof typeof UPLOAD_FIELDS;

const isUploadFieldApplicable = (field: UploadConfigField, deliveryMethod: string) =>
    UPLOAD_FIELDS[field].methods.includes(deliveryMethod);

export const useUploadConfigFieldState = (form: UseFormReturn<any>) => {
    const enabled: boolean = form.watch('enabled');
    const deliveryMethod: string = form.watch('deliveryMethod');
    const isApplicable = (field: UploadConfigField) => isUploadFieldApplicable(field, deliveryMethod);
    return { enabled, isApplicable };
};

export const clearInapplicableUploadFields = <T extends { deliveryMethod: string }>(values: T): T => {
    const cleared: Record<string, unknown> = { ...values };
    (Object.keys(UPLOAD_FIELDS) as UploadConfigField[]).forEach((field) => {
        // Only the orders form has the additional-files fields; don't inject them into other forms' payloads.
        if (field in cleared && !isUploadFieldApplicable(field, values.deliveryMethod)) {
            cleared[field] = UPLOAD_FIELDS[field].clearedValue;
        }
    });
    return cleared as T;
};
